import { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import { Flashbar } from "@amzn/awsui-components-react";

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";
import Paths from "../../common/paths/paths";
import { useFlashBarItems } from "../../common/UseFlashBarItems/useFlashBarItems";
import useAppDrawers from "../../components/ChatbotWidget/useAppDrawers";
import { POConfigurationTable } from "../../components/POConfiguration/POConfigurationTable";

const breadcrumbs = {
    items: [
        { text: Paths.Admin.name, href: Paths.uploadLicense.url },
        { text: Paths.poConfiguration.name, href: Paths.poConfiguration.url },
    ],
};

const POConfigurationPage = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const flashBarItemsHook = useFlashBarItems();
    const drawerProps = useAppDrawers();

    return (
        <AppLayout
            content={<POConfigurationTable useFlashBarItemsActions={flashBarItemsHook.actions} />}
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems />}
            onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
            toolsHide={true}
            {...drawerProps}
        />
    );
};

export default POConfigurationPage;
